import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { addressErrors } from "common/functions";
import FieldEditor from "components/FieldEditor";
import * as fields from "pages/clientPortfolio/businessClient/businessClientFieldDefinitions";
import { useEffect, useState } from "react";
import { AddressType, FieldError, BusinessClient } from "types";

type Props = {
  onAdd(newAddress: AddressType): void;
  onCancel(): void;
};

export default function AddAddressHstoryItem({ onAdd, onCancel }: Props) {
  const [state, setState] = useState<BusinessClient>({});
  const [errors, setErrors] = useState<FieldError[]>([]);

  function checkNewAddressErrors() {
    const addressErrorsArray: FieldError[] = [
      ...addressErrors(fields.businessNewAddress, state),
    ];
    //Invalid postal code fix: following code checks for invalid postal code. Adds error if length is less than 7
    if (
      state.information?.businessNewAddress?.postalCode &&
      state.information.businessNewAddress.postalCode?.length < 7
    ) {
      let invalidPostalCodeErr: FieldError = {
        id: `${fields.businessNewAddress.id}_postalCode`,
        label: "Postal Code",
        error: "Invalid Postal Code.",
      };
      addressErrorsArray.push(invalidPostalCodeErr);
    }
    setErrors(addressErrorsArray);
    return addressErrorsArray;
  }

  useEffect(() => {
    errors.length > 0 && checkNewAddressErrors();
  }, [state]);

  return (
    <Dialog maxWidth={"md"} open>
      <DialogTitle>Add Address</DialogTitle>
      <DialogContent>
        <FieldEditor<BusinessClient>
          field={fields.businessNewAddress}
          state={state}
          setState={setState}
          errors={errors}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            const newAddressErrors = checkNewAddressErrors();
            if (newAddressErrors.length === 0) {
              onAdd(
                {
                  ...state.information?.businessNewAddress,
                  country: "Canada",
                } || {}
              );
            }
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
